import { useRouteError, isRouteErrorResponse, Link } from "react-router";

export function RootErrorBoundary() {
  const error = useRouteError();
  const status = isRouteErrorResponse(error) ? error.status : 500;
  const message = isRouteErrorResponse(error)
    ? error.statusText
    : error instanceof Error
      ? error.message
      : "Unexpected error";

  return (
    <div className="flex min-h-screen items-center justify-center px-6">
      <div className="max-w-md space-y-4 text-center">
        <p className="text-xs uppercase tracking-widest text-muted-foreground">
          Error {status}
        </p>
        <h1 className="text-2xl font-semibold">Something went sideways.</h1>
        <p className="text-sm text-muted-foreground">{message}</p>
        <Link
          to="/"
          className="inline-flex items-center text-sm font-medium text-accent underline-offset-4 hover:underline"
        >
          Take me home
        </Link>
      </div>
    </div>
  );
}
